<div class="signer-wrapper">
  <div class="signer-position" [ngStyle]="wrapperStyles()">
    <div class="signer-position-descr">
      <span class="signer-position-descr-contact">{{ identification }}</span>
      <span class="monster__badge badge-S badge-neutral">{{ 'signature.signAction.' + (signatureAction | lowercase) | translate }}</span>
    </div>
    <div class="signer-position-content">
      <button class="btn-S btn-outline" [class.disabled]="disabled" (click)="!disabled && addFloatingField.emit(PositionElementEnum.Signature)">
        {{ 'signature.signature' | translate }}
      </button>
      @if (!qualified && !signerQualified) {
        <button class="btn-S btn-outline" [class.disabled]="disabled" (click)="!disabled && addFloatingField.emit(PositionElementEnum.Initials)">
          {{ 'signature.initials' | translate }}
        </button>
        <button class="btn-S btn-outline" [class.disabled]="disabled" (click)="!disabled && addFloatingField.emit(PositionElementEnum.Name)">{{ 'signature.name' | translate }}</button>
        @if (isCountryBR) {
          <button class="btn-S btn-outline" [class.disabled]="disabled" (click)="!disabled && addFloatingField.emit(PositionElementEnum.Cpf)">
            {{ 'signature.cpf' | translate }}
          </button>
        }
        <button class="btn-S btn-outline" [class.disabled]="disabled" (click)="!disabled && addFloatingField.emit(PositionElementEnum.Date)">{{ 'signature.date' | translate }}</button>
      }
    </div>
  </div>
</div>
